import { defineComponent as p, computed as c, withDirectives as u, createElementBlock as m, openBlock as i, mergeProps as d, vModelText as f } from "vue";
const g = /* @__PURE__ */ p({
  __name: "ServerVariablesTextbox",
  props: {
    value: {},
    controls: {}
  },
  emits: ["change"],
  setup(l, { emit: r }) {
    const a = l, n = r, t = c({
      get: () => a.value,
      set: (e) => n("change", e)
    });
    return (e, o) => u((i(), m("input", d({
      "onUpdate:modelValue": o[0] || (o[0] = (s) => t.value = s)
    }, e.controls ? { ...e.$attrs, "aria-controls": e.controls } : {}, {
      autocomplete: "off",
      class: "text-c-1 w-full border-transparent px-1.5 py-1.25 -outline-offset-1 group-last/label:rounded-br-lg",
      placeholder: "value",
      spellcheck: "false",
      type: "text"
    }), null, 16)), [
      [f, t.value]
    ]);
  }
});
export {
  g as default
};
